import type {EntityType} from 'src/types/ats-entities';
import type {StandardEntity} from 'src/types/target-entity-types';
import type {TranslationFunction} from 'src/types/language-support';


export const JOB_MATCH_ADDON_ID = 'sense-job-match-row';
export const JOB_MATCH_LINK_TEXT = 'Configure Job Match';

export const JOB_MATCH_API_PATH = '/bff/api/v1/';
export const JOB_MATCH_QUERY_PARAMS_PATH = 'discover/job-match/query-params';
export const JOB_MATCH_SENSE_APP = 'engage';
export const JOB_MATCH_DEFAULT_RULES_PATH = 'j2-job-match-params';

export const STANDARD_ENTITY_CANDIDATE: StandardEntity = 'candidate';
export const FALLBACK_CANDIDATE_ENTITY_TYPE: EntityType = 'bh_candidate';

export const METADATA_EXCLUDED_KEYS = new Set([
  'maxResults',
  'fieldsToShow',
  'jobMatchType',
  'variableIdentifier',
  'placeholder',
]);

export const PANEL_STATES = {
  JOB_MATCHING: 'jobMatching',
  CUSTOMIZE: 'customize',
} as const;

export type PanelState = typeof PANEL_STATES[keyof typeof PANEL_STATES];

export const JOB_TITLE_FIELD_VALUE = 'job_title';

export const FIELDS_TO_SHOW_OPTIONS = [
  {label: 'Job Title', value: JOB_TITLE_FIELD_VALUE},
  {label: 'Zip', value: 'zip'},
  {label: 'City', value: 'city'},
  {label: 'State', value: 'state'},
  {label: 'Country', value: 'country'},
  {label: 'Pay Rate', value: 'pay_rate'},
  {label: 'Contract Duration', value: 'contract_duration'},
  {label: 'Shift', value: 'shift'},
  {label: 'Discipline', value: 'discipline'},
  {label: 'Speciality', value: 'speciality'},
  {label: 'Certification', value: 'certification'},
] as const;

export const MAX_FIELDS_TO_SHOW = 5;

export const getJobMatchInfoBlockHTML = (t: TranslationFunction) => `
  <div
    contenteditable="false"
    data-locked="true"
    style="background:#E6F0FE;border:1px solid #EBEBEB;padding:20px;display:flex;gap:12px;align-items:flex-start;user-select:none;"
  >
    <div style="display:flex;flex-direction:column;gap:8px;">
      <div style="font-family: 'Centra No 2', sans-serif;font-size:16px;color:#17172A;">${t(
        'Matched_Jobs',
        'Matched Jobs',
      )}</div>

      <div style="font-family: 'Centra No 2', sans-serif;font-size:12px;color:#17172A;">${t(
        'Jobs_matching_the_candidate\'s_preferences_will_appear_below_in_an_easytoscan_table_format',
        'Jobs matching the candidate\'s preferences will appear below in an easy-to-scan table format.',
      )}</div>
    </div>
  </div>
`;
